export default __webpack_public_path__ + "static/media/Harness 2.82dd3a17.png";